import { v4 as uuid } from 'uuid'

import {
  replaceCloseTag,
  replaceOpenTag,
  closeTagPattern,
  openTagPattern,
} from 'components/MCTextEditor/formatting/adapter'
import { SliceType } from 'components/MCTextEditor/slice/types'
import { makeSmartLinkReplacer, SmartLinkPattern } from 'components/MCTextEditor/smartLinks/adapter'
import { makeVariableReplacer, VariablePattern } from 'components/MCTextEditor/variables/adapter'
import { createFragment } from 'components/RichTextEditor/processor/range'

import { parse } from './mapReduceParser/parse'
import { ParserMapFunction } from './mapReduceParser/types'
import { ParserContext, ParserResult } from './types'
import { replaceAll } from './utils/replace'
import { makeSplit } from './utils/splitByRegExps'

export const split = makeSplit([VariablePattern, SmartLinkPattern, openTagPattern, closeTagPattern])

const makeMap =
  (context: ParserContext): ParserMapFunction =>
  (input: string[]) => {
    return replaceAll(input, [
      makeVariableReplacer(context.variables?.getLabelById, context.variables?.getPreviewValue),
      makeSmartLinkReplacer(context.smartLinks?.getLabelById, context.smartLinks?.getButtonById),
      replaceOpenTag,
      replaceCloseTag,
    ])
  }

export const parseMCText = (input: string, context: ParserContext): ParserResult => {
  const parseResult = parse(input, split, makeMap(context))

  const slices = parseResult.items.map((item) => {
    const slice = createFragment(item.start, item.length, {
      type: item.name,
      data: item.data,
    })
    if (slice.type === SliceType.VARIABLE || slice.type === SliceType.SMART_LINK) {
      slice.id = uuid()
    }
    return slice
  })

  return { text: parseResult.text, slices }
}
